import script from "./Gallery.vue?vue&type=script&setup=true&lang=js"
export * from "./Gallery.vue?vue&type=script&setup=true&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=2a734784&lang=scss&scoped=true"
import "./Gallery.vue?vue&type=style&index=1&id=2a734784&lang=scss"
import "./Gallery.vue?vue&type=style&index=2&id=2a734784&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a734784"]])

export default __exports__